export default {
    dropdown: 90,
    modal: 100
};



// WEBPACK FOOTER //
// ./app/themes/default-theme/z-index.js